// The CSV rules every Finance export shares (spec 2026-09-22 §6): one
// escaping pass, one formula guard, one download. Two exports use it — the
// payouts list (payouts-export.js) and the payout detail
// (pages/payout-detail-export.js) — and the guard is exactly the sort of
// thing that rots when it is copied.

// A field starting with =, +, @, a tab/CR, or a - not followed by a digit
// (Amount legitimately reads "-3.00" for a negative payout) opens as a
// formula in Excel/Sheets. A leading single quote defuses it there without
// changing what the cell reads as plain text.
const FORMULA_LEAD = /^([=+@\t\r]|-\D)/;

export const csvCell = (value) => {
  const text = value == null ? '' : String(value);
  const defused = FORMULA_LEAD.test(text) && Number.isNaN(Number(text));
  const safe = defused ? `'${text}` : text;
  // A defused field is always quoted too: Excel treats a quoted field
  // starting with a literal apostrophe as text far more reliably than an
  // unquoted one.
  return defused || /[",\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export const csvRow = (values) => values.map(csvCell).join(',');

export const downloadCsv = (text, filename) => {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Not in the same task as the click: Firefox and Safari have both been
  // observed to cancel a download whose blob URL is revoked before the
  // navigation it started has a chance to begin.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
